// D:\Workspace\paperplay\frontend\src\constants\appRoutes.ts

import { RouteSlug } from './routeSlugs';

export const ROUTE_DEFINITIONS: Record<RouteSlug, string> = {
  // Core
  [RouteSlug.DASHBOARD]: '/dashboard',
  [RouteSlug.PROFILE]: '/profile',
  [RouteSlug.PAYMENTS]: '/payments',
  [RouteSlug.BOOKINGS]: '/bookings',
  [RouteSlug.MESSAGES]: '/messages',
  [RouteSlug.MARKETPLACE]: '/marketplace',
  [RouteSlug.GIGS]: '/gigs',
  [RouteSlug.SUPPORT]: '/support',
  [RouteSlug.LOGOUT]: '/logout',
  [RouteSlug.FAVORITES]: '/favorites',

  // org-scoped dashboards
  [RouteSlug.DASHBOARD_ARTIST]: '/dashboard/artist/:organizationId',
  [RouteSlug.DASHBOARD_VENUE]: '/dashboard/venue/:organizationId',
  [RouteSlug.DASHBOARD_HOST]: '/dashboard/host/:userId',

  // Account-Settings
  [RouteSlug.ACCOUNT_USERPROFILE]: '/accountsettings/userprofile',
  [RouteSlug.ACCOUNT_USERPROFILE_WITHID]: '/accountsettings/userprofile/:userId',
  [RouteSlug.ACCOUNT_PROFILEPAGE]: '/account',
  [RouteSlug.ACCOUNT_ACCOUNTDETAILS]: '/account',
  [RouteSlug.ACCOUNT_MANAGEPREFERENCES]: '/account/manage-preferences',
  [RouteSlug.ACCOUNT_AUTHDEVICES]: '/account/authorized-devices',
  [RouteSlug.ACCOUNT_BILLINGHISTORY]: '/account/billing-history',
  [RouteSlug.ACCOUNT_CONNECTEDACCOUNTS]: '/account/connected-accounts',
  [RouteSlug.ACCOUNT_FORGOTPASSWORD]: '/account/forgot-password',
  [RouteSlug.ACCOUNT_PASSWORD]: '/account/password',
  [RouteSlug.ACCOUNT_SUBSCRIPTIONMANAGEMENT]: '/account/subscription-management',
  [RouteSlug.ACCOUNT_TWOFACTORAUTH]: '/account/two-factor-auth',

  // Authorization
  [RouteSlug.AUTH_HOME]: '/',
  [RouteSlug.AUTH_REGISTER]: '/register',
  [RouteSlug.AUTH_CHECK_EMAIL]: '/check-email',
  [RouteSlug.AUTH_VERIFY_ACCOUNT]: '/verify-account',
  [RouteSlug.AUTH_VERIFY_USER]: '/verify-user',
  [RouteSlug.AUTH_IMPERSONATION_BOOTSTRAP]: '/impersonation/bootstrap',
  [RouteSlug.AUTH_LOGIN]: '/login',
  [RouteSlug.AUTH_UNAUTHORIZED]: '/unauthorized',
  [RouteSlug.AUTH_PWRESET_REQUEST]: '/password-reset/request',
  [RouteSlug.AUTH_PWRESET_CHANGE]: '/password-reset/change',
  [RouteSlug.AUTH_PWRESET_FORGOT]: '/password-reset/forgot',
  [RouteSlug.AUTH_PWRESET_RESET]: '/password-reset/reset',
  [RouteSlug.AUTH_NOT_FOUND]: '/404-or-whatever',
  [RouteSlug.AUTH_PWRESET_SMS_CONFIRM]: '/password-reset/sms/confirm',

  // Artist
  [RouteSlug.ARTIST_CONFIRMATION]: '/artist/confirmation',
  [RouteSlug.ARTIST_CREATE]: '/artist/create',
  [RouteSlug.ARTIST_DETAIL]: '/artist/detail/:artistId',
  [RouteSlug.ARTIST_PROFILE_WITHID]: '/artist/:artistId/profile',
  [RouteSlug.ARTIST_PROFILE_ORG]: '/artist/org/:organizationId/profile',
  [RouteSlug.ARTIST_LIST]: '/artist/list',
  [RouteSlug.ARTIST_MEMBERSHIP]: '/artist/membership',
  [RouteSlug.ARTIST_PROFILE_NOID]: '/artist/profile',
  [RouteSlug.ARTIST_EVENTS_DASHBOARD]: '/artist/event/dashboard',

  // **Public profile routes (do NOT collide with /artists marketing)**
  [RouteSlug.PUBLIC_ARTIST_PROFILE_BY_HANDLE]: '/@:handle',
  [RouteSlug.PUBLIC_ARTIST_PROFILE_WITHID]: '/artist/public/:artistId',
  [RouteSlug.PUBLIC_VENUE_PROFILE_WITHID]: '/venue/public/:venueId',
  [RouteSlug.ARTIST_BAND_INVITE_RESPONSE]: '/band/invites/:token',
  [RouteSlug.ARTIST_BAND_LINKED_INVITE_RESPONSE]: '/band/invites/linked/:attemptId',

  // Booking
  [RouteSlug.ARTIST_BOOKINGS_DASHBOARD]: '/artist/bookings/:organizationId',
  [RouteSlug.VENUE_BOOKINGS_DASHBOARD]: '/venue/bookings/:organizationId',
  [RouteSlug.BOOKING_LIST]: '/booking',
  [RouteSlug.BOOKING_DASHBOARD]: '/booking/dashboard',
  [RouteSlug.BOOKING_CREATE]: '/booking/:organizationId/create',
  [RouteSlug.BOOKING_DETAIL]: '/booking/:bookingId',
  [RouteSlug.BOOKING_UPDATE]: '/booking/:bookingId/update',
  [RouteSlug.BOOKING_DELETE]: '/booking/:bookingId/delete',
  [RouteSlug.BOOKING_COUNTER_OFFER]: '/booking/:bookingId/counter-offer',
  [RouteSlug.BOOKING_NEGOTIATION]: '/booking/:bookingId/negotiation',
  [RouteSlug.BOOKING_ANALYTICS]: '/booking/analytics',
  [RouteSlug.BOOKING_PAGE]: '/bookingPage',
  [RouteSlug.BOOKINGS_MARKETPLACE]: '/bookings/marketplace',

  // Calendars
  [RouteSlug.CALENDAR_DASHBOARD]: '/calendar/dashboard',
  [RouteSlug.CALENDAR_EVENT_LIST]: '/calendar/event',
  [RouteSlug.CALENDAR_AVAILABILITY]: '/calendar/availability',
  [RouteSlug.CALENDAR_EVENT_CREATE]: '/calendar/event/create',
  [RouteSlug.CALENDAR_EVENT_EDIT]: '/calendar/event/:eventId/edit',
  [RouteSlug.CALENDAR_EVENT_DETAILS]: '/calendar/event/:eventId/details',
  [RouteSlug.CALENDAR_VENUE]: '/gigs/calendar',
  [RouteSlug.REPORTED_SHOW_CONFIRMATION]: '/reported-show-confirmations/:token',

  // Collaborators
  [RouteSlug.COLLABORATORS_MANAGE]: '/collaborators/manage',
  [RouteSlug.COLLABORATORS_INVITE]: '/collaborators/invite',
  [RouteSlug.COLLABORATOR_INVITE_ACCEPT]: '/invites/collaborator',
  [RouteSlug.COLLABORATOR_INVITE_REDEEM]: '/invites/collaborator/redeem',

  // ✅ NEW: Event collaborator invite accept route
  [RouteSlug.EVENT_COLLABORATOR_INVITE_ACCEPT]: '/invites/event-collaborator',

  // Shareable invite links. Must match the mobile app's App Link path exactly
  // (paperplay-mobile app/i/[code].tsx) — the two resolve the same URL.
  [RouteSlug.SHARE_INVITE]: '/i/:code',

  [RouteSlug.COLLABORATORS_ROLES]: '/collaborators/roles',
  [RouteSlug.COLLABORATORS_PERMISSIONS]: '/collaborators/permissions',
  [RouteSlug.COLLABORATORS_AUDIT_LOG]: '/collaborators/audit-log',

  // Communities
  [RouteSlug.COMMUNITIES]: '/communities',
  [RouteSlug.MY_COMMUNITIES]: '/communities/my',
  [RouteSlug.COMMUNITY_DETAIL]: '/c/:slug',
  [RouteSlug.COMMUNITY_INVITE_REDEEM]: '/invites/:token',
  [RouteSlug.COMMUNITY_CREATE]: '/communities/create',
  [RouteSlug.COMMUNITIES_SEARCH]: '/communities/search',
  [RouteSlug.COMMUNITY_SETTINGS]: '/communities/:slug/settings',
  [RouteSlug.COMMUNITY_JOIN]: '/communities/:slug/join',

  // Gig Terms / Templates
  [RouteSlug.GIGTERMS_INDEX]: '/gigterms',
  [RouteSlug.GIGTERMS_MASTER]: '/gigterms/master',
  [RouteSlug.GIGTERMS_VENUE]: '/gigterms/venues/:venueId',
  [RouteSlug.GIGTEMPLATES_LIST]: '/gigterms/venues/:venueId/templates',
  [RouteSlug.GIGTEMPLATES_CREATE]: '/gigterms/venues/:venueId/templates/create',
  [RouteSlug.GIGTEMPLATES_EDIT]: '/gigterms/venues/:venueId/templates/:templateId/edit',
  [RouteSlug.GIGTEMPLATES_SERIES]: '/gigterms/venues/:venueId/templates/:templateId/series',

  // --- venue-local templates/utilities ---
  [RouteSlug.VENUE_TEMPLATES_LIST]: '/venue/:venueId/templates',
  [RouteSlug.VENUE_TEMPLATES_CREATE]: '/venue/:venueId/templates/create',
  [RouteSlug.VENUE_CONTRACT_TERMS]: '/venue/:venueId/contract-terms',
  [RouteSlug.VENUE_OPEN_GIG]: '/venue/:venueId/open-gig',

  // Event
  [RouteSlug.EVENT_CREATE]: '/event/create',
  [RouteSlug.EVENT_LIST]: '/event',
  [RouteSlug.EVENT_DASHBOARD]: '/event/dashboard',
  [RouteSlug.EVENT_DETAIL]: '/event/:eventId',
  [RouteSlug.EVENT_EDIT]: '/event/:eventId/edit',
  [RouteSlug.EVENT_DELETE]: '/event/:eventId/delete',
  [RouteSlug.EVENT_COMPLETION]: '/event/:eventId/completion',
  [RouteSlug.EVENT_FACIAL_RECOGNITION]: '/event/:eventId/facial-recognition',
  [RouteSlug.EVENT_PITCH_VIEW]: '/event/:eventId/pitch',
  [RouteSlug.VENUE_EVENT_DETAIL]: '/venue/event/:eventId',

  // Help and Support
  [RouteSlug.SUPPORT_HOME]: '/support',
  [RouteSlug.SUPPORT_SUBMIT_REQUEST]: '/support/submit-request',
  [RouteSlug.SUPPORT_FAQ]: '/support/faq',
  [RouteSlug.SUPPORT_TRAINING]: '/support/training',
  [RouteSlug.SUPPORT_TRAINING_AUDIENCE]: '/support/training/:audience',
  [RouteSlug.SUPPORT_REQUEST_DETAIL]: '/support/support-request/:requestId',
  [RouteSlug.ADMIN_SUPPORT_REQUEST]: '/admin/support/request',
  [RouteSlug.ADMIN_SUPPORT_FAQ]: '/admin/support/faq',
  [RouteSlug.SUPPORT_REQUEST_LIST]: '/support/request-list',

  // Payment
  [RouteSlug.ARTIST_PAYMENTS_DASHBOARD]: '/artist/payments/:organizationId',
  [RouteSlug.VENUE_PAYMENTS_DASHBOARD]: '/venue/payments/:organizationId',
  [RouteSlug.PAYMENT_DASHBOARD]: '/payment/dashboard',
  [RouteSlug.PAYMENT_TRANSACTION_LIST]: '/payment/transaction',
  [RouteSlug.PAYMENT_TRANSACTION_NEW]: '/payment/transaction/new',
  [RouteSlug.PAYMENT_TRANSACTION_DETAIL]: '/payment/transaction/:transactionId',
  [RouteSlug.PAYMENT_TRANSACTION_UPDATE]: '/payment/transaction/:transactionId/update',
  [RouteSlug.PAYMENT_TRANSACTION_DELETE]: '/payment/transaction/:transactionId/delete',
  [RouteSlug.PAYMENT_REFUND]: '/payment/refund/:transactionId',
  [RouteSlug.PAYMENT_REALTIME_REPORT]: '/payment/realtime/report',
  [RouteSlug.PAYMENT_EXTERNAL_SYNC]: '/payment/external/sync',
  [RouteSlug.PAYMENT_ANALYTIC_TRANSACTION]: '/payment/analytic/transaction',
  [RouteSlug.PAYMENT_ANALYTICS]: '/payment/analytics',
  [RouteSlug.PAYMENT_METHOD_LIST]: '/payment/method',
  [RouteSlug.PAYMENT_METHOD_DETAIL]: '/payment/method/:methodId',
  [RouteSlug.PAYMENT_METHOD_UPDATE]: '/payment/method/:methodId/update',
  [RouteSlug.PAYMENT_METHOD_DELETE]: '/payment/method/:methodId/delete',
  [RouteSlug.PAYMENT_CONDITION_UPDATE]: '/payment/payment-condition/:conditionId/update',
  [RouteSlug.PAYMENT_CONDITION_DELETE]: '/payment/payment-condition/:conditionId/delete',
  [RouteSlug.PAYMENT_SET_SPLIT]: '/payment/set-payment-splits',
  [RouteSlug.PAYMENT_REGISTER_USER]: '/payment/register-user',
  [RouteSlug.PAYMENT_PAYOUTS_INSTANT]: '/payment/payouts/instant',
  [RouteSlug.PAYMENT_PAYOUTS_HISTORY]: '/payment/payouts/history',
  [RouteSlug.PAYMENT_PAYOUT_METHODS]: '/payment/payout-methods',
  [RouteSlug.PAYMENT_DISPUTES]: '/payment/disputes',
  [RouteSlug.PAYMENT_EVENT_ROUTE]: '/payments/:eventId/route',
  [RouteSlug.PAYMENT_EVENT_ESCROW]: '/payments/:eventId/escrow',
  [RouteSlug.PAYMENT_EVENT_OVERTIME]: '/payments/:eventId/overtime',
  [RouteSlug.PAYMENT_EVENT_TIPS]: '/payments/:eventId/tips',
  [RouteSlug.PAYMENT_EVENT_SPLIT]: '/payments/:eventId/split',
  [RouteSlug.PAYMENT_EVENT_SUCCESS]: '/payments/:eventId/success',
  [RouteSlug.PAYMENT_EVENT_CXL_POLICY]: '/events/:eventId/cancellation-policy',
  [RouteSlug.PAYMENT_CXL_POLICY]: '/cancellation-policy',

  // Messages
  [RouteSlug.MESSAGES_ARTIST]: '/artist/messages/:organizationId',
  [RouteSlug.MESSAGES_ARTIST_CHANNEL]: '/artist/messages/:organizationId/channel/:channelId',
  [RouteSlug.MESSAGES_ARTIST_CHANNEL_READRECEIPT]:
    '/artist/messages/:organizationId/channel/:channelId/read-receipt/:messageId',
  [RouteSlug.MESSAGES_VENUE]: '/venue/messages/:organizationId',
  [RouteSlug.MESSAGES_VENUE_CHANNEL]: '/venue/messages/:organizationId/channel/:channelId',
  [RouteSlug.MESSAGES_VENUE_CHANNEL_READRECEIPT]:
    '/venue/messages/:organizationId/channel/:channelId/read-receipt/:messageId',
  [RouteSlug.MESSAGES_ACCOUNT]: '/account/messages',
  [RouteSlug.MESSAGES_ACCOUNT_CHANNEL]: '/account/messages/:channelId',
  [RouteSlug.MESSAGE_INDEX]: '/message',
  [RouteSlug.CHANNEL_DETAIL]: '/channel/:channelId',
  [RouteSlug.CHANNEL_MESSAGES]: '/channel/:channelId/message',
  [RouteSlug.CHANNEL_READ_RECEIPT]: '/channel/:channelId/read-receipt/:messageId',
  [RouteSlug.ADMIN_CHANNEL]: '/admin/channel',
  [RouteSlug.ADMIN_MESSAGE]: '/admin/message',
  [RouteSlug.CHANNEL_LIST]: '/channel/list/:channelId',

  // Venue
  [RouteSlug.VENUE_DETAIL]: '/venue/:venueId',
  [RouteSlug.VENUE_EDIT]: '/venue/:venueId/edit',
  [RouteSlug.VENUE_CREATE]: '/venue/create',
  [RouteSlug.VENUE_REGISTER]: '/venue/register',
  [RouteSlug.VENUE_DASHBOARD]: '/dashboard',
  [RouteSlug.VENUE_PROFILE_WITHID]: '/venue/:venueId/profile',
  [RouteSlug.VENUE_PROFILE_ORG]: '/venue/org/:organizationId/profile',
  [RouteSlug.VENUE_LIST]: '/venue/list',

  // Organization admin
  [RouteSlug.ORG_TEAM]: '/organizations/:orgId/team',
  [RouteSlug.ORG_ROLES]: '/organizations/:orgId/roles',

  // Notifications
  [RouteSlug.NOTIFICATIONS]: '/notifications',

  // Host (new)
  [RouteSlug.HOST_GUEST_CHECKIN]: '/host/guest-checkin',
  [RouteSlug.HOST_DASHBOARD]: '/host/dashboard',
};
